// 只能输入通过正则条件的字符
export default {
  // 1. 第一次绑定
  bind(el, binding, vnode) {
    // 将正则提取为组件级别的统一处理函数
    const getRegex = val => (val instanceof RegExp ? val : null);

    // 把当前正规挂载到 el 属性上，方便动态更新
    el._currentRegex = getRegex(binding.value);

    el._handler = e => {
      // 关键：每次触发 input 事件时，永远读取 el 上最新的正则
      if (!el._currentRegex) return;

      const originalValue = e.target.value;
      const filteredValue = originalValue.replace(el._currentRegex, "");

      // 只有在真正发生被过滤、替换时，才去改变值和触发更新，避免不必要的抖动
      if (originalValue !== filteredValue) {
        e.target.value = filteredValue;
        // 触发 v-model 更新
        if (vnode.componentInstance) {
          vnode.componentInstance.$emit("input", filteredValue);
        } else {
          // 兼容原生 input 的情况
          e.target.dispatchEvent(new Event("input"));
        }
      }
    };

    el.addEventListener("input", el._handler);
  },

  // 2. 关键补全：当绑定值（三元表达式结果）发生变化时触发
  update(el, binding) {
    // 如果新值和旧值一样，不需要任何操作
    if (binding.value === binding.oldValue) return;

    // 动态将 el 上保存的正则更新为最新传入的正则
    el._currentRegex = binding.value instanceof RegExp ? binding.value : null;
  },

  // 3. 解绑销毁
  unbind(el) {
    el.removeEventListener("input", el._handler);
    delete el._handler;
    delete el._currentRegex;
  },
};
